<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import apigeneric from "@/helpers/apigeneric";
import Loader from "@/components/widgets/loader";
import Banner from "../components/banner";
import apibtoast from "@/helpers/apibtoast";

export default {
  page: {
    title: "Web Siteleri",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    Loader,
    Banner

  },
  mixins: [apigeneric, apibtoast],
  data() {
    return {
      TableData: null,
      PersonellerTitle: {},
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      currentUrl: null



    };
  },
  created() {
    this.currentUrl = window.location.host;
    },
    
  methods: {
    Get() {

      this.ActionsFilterGet({
        Service: "AkademikPersonel",
        Page: this.Page,
        Filter: "&Siteurl=http://" + this.currentUrl
      }).then((res) => {
        this.TableData = this.groupBy(res.Data, 'BölümAdi')
        this.Page.PageDataSize = res.TotalCount;
      });

      

    },
    groupBy(array, key) {
      const result = {}
      array.forEach(item => {
        if (!result[item[key]]) {
          result[item[key]] = []
        }
        result[item[key]].push(item)
      })
      return result
    }
  },
};
</script>
        
<template>
  <Loader>
    <Layout>
      <Banner /> 
      <div class="title c-flex flex-column mt-5">
                <h2>{{$t("Personeller.AkademikPersoneller.Title")}}</h2>
            </div> 
      <div v-for="(BölümAdi,index) in TableData" :key="index">
        <div class="title c-flex flex-column mt-5">
                <h4>{{BölümAdi[0].BölümAdi}}</h4>
            </div> 
        <div class="row mt-5 mb-3">
        <div  id="card" class="card bg-gradient text-light text-center" v-for="(Personel,index) in BölümAdi" :key="index" 
        style="background-color:#2774AE; box-shadow: 5px 5px 5px #888888; ">
          <div>
            <img v-if="Personel.Foto" class="card-img-top mt-2" :src="$config.FILES_URL + 'web/' + Personel.Foto" alt="Personel image"
              style="width:100%; border-radius:10px">
            <img v-if="Personel.Foto==null" class="card-img-top mt-2" src="@/assets/images/personelicon.png"
              alt="Personel image" style="width:100%; border-radius:10px">
          </div>
          <div class="card-body">
            <h4 class="card-title text-light xs">{{ Personel.AdSoyad }}</h4>
            <p class="card-text">{{Personel.Mail}}</p>
          </div>
        </div>
        </div>
        <hr>
      </div>
   

     
    
    </Layout>
  </Loader>
</template>

<style>
#card {
  max-width: 250px;
  margin-right: 10px;
  margin-left: 40px;

}
</style>
        